import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import StickyQuoteBar from "@/components/StickyQuoteBar";

export default function Layout({ children }) {
  return (
    <div className="App min-h-screen flex flex-col bg-sand-100">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <StickyQuoteBar />
      <ChatWidget />
    </div>
  );
}
